export default __webpack_public_path__ + "2fd022359354a85f195ed92754ea4d68.jpg";